export default __webpack_public_path__ + "static/media/tcrb.80d8b144.svg";